import { useState } from 'react';
import { CheckCircle2, LockKeyhole, Mail, UserRound } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';
import { primarySupabase } from '../lib/supabase';

/** Optional public-game account. Guest play remains available with a private Career Key. */
export default function GameAccountPanel() {
  const { user, loading, signOut } = useAuth();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [error, setError] = useState(false);

  async function submit(event) {
    event.preventDefault();
    if (busy || !email.trim()) return;
    setBusy(true);
    setFeedback('');
    setError(false);
    try {
      const { error: resultError } = await primarySupabase.auth.signInWithOtp({
        email: email.trim().toLowerCase(),
        options: { shouldCreateUser: true, emailRedirectTo: `${window.location.origin}/games` },
      });
      if (resultError) throw resultError;
      setFeedback('Check your inbox for a secure link. Once you sign in, your existing guest career on this device will be linked automatically.');
    } catch {
      setError(true);
      setFeedback('Could not send your sign-in link. Try again in a moment.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="arcade-account" aria-label="Free game account">
      <div className="arcade-account__intro">
        <span className="arcade-account__icon">{user ? <CheckCircle2 size={22} /> : <UserRound size={22} />}</span>
        <div><h2>{user ? 'Your arcade account is ready' : 'Keep your towing career'}</h2>
          <p>{user
            ? 'Your Dispatch Dash progress will be tied to your email after opening the game. Play across devices by signing in again.'
            : 'Play as a guest, or create a free email-link account to keep your Dispatch Dash cash, trucks, upgrades and contracts across devices.'}</p>
        </div>
      </div>
      {user
        ? <div className="arcade-account__actions"><span className="arcade-account__email"><LockKeyhole size={15} />Signed in · {user.email}</span><button type="button" onClick={async () => { setFeedback(''); await signOut(); }}>Sign out</button></div>
        : <form className="arcade-account__form" onSubmit={submit}><label htmlFor="arcade-account-email">Email address</label><div><input id="arcade-account-email" type="email" autoComplete="email" required placeholder="you@example.com" value={email} onChange={event => setEmail(event.target.value)} disabled={busy || loading}/><button type="submit" disabled={busy || loading}><Mail size={16} />{busy ? 'Sending…' : 'Save my career'}</button></div><small>No password or payment needed. Existing guest Career Keys still work.</small></form>}
      {feedback && <p className={error ? 'arcade-account__error' : 'arcade-account__success'} role={error ? 'alert' : 'status'}>{feedback}</p>}
    </section>
  );
}
